import React from 'react';
import glamorous from 'glamorous';
import { AutoAffix } from 'react-overlays';
import { hashHistory } from 'react-router';
import { get, includes, filter } from 'lodash';
import { compose, withHandlers, withState } from 'recompose';

import DocMenu from './doc-menu';
import CurrentSection from './current-section';
import withScrollToSubSection from './with-scroll-to-subsection-hoc';

const ImportDocumentation = (props) => {
  const querySection = get(props, 'location.query.section', 'scope');

  return (
    <div className="container">
      <div className="col-md-3">
        <AutoAffix container={this}>
          <glamorous.Div css={{
            maxHeight: 'calc(100vh - 130px)',
            overflowY: 'auto',
          }}>
            <DocMenu
              onSectionChange={props.onSectionChange}
              currentSection={querySection}
              expandedNodeIds={props.expandedNodeIds}
              onNodeExpandToggle={props.onNodeExpandToggle}
            />
          </glamorous.Div>
        </AutoAffix>
      </div>
      <glamorous.Div className="col-md-9">
        <CurrentSection onSectionChange={props.onSectionChange} section={querySection}/>
      </glamorous.Div>
    </div>
  )
};

export default compose(
  withState('expandedNodeIds', 'setExpandedNodeIds', []),
  withHandlers({
    onSectionChange: () => (section) => {
      const curLocation = hashHistory.getCurrentLocation();
      hashHistory.push({ ...curLocation, query: { section } });
    },
    onNodeExpandToggle: (props) => (node) => {
      const isRemove = includes(props.expandedNodeIds, node.id);
      const nextExpandedNodeIds = isRemove
        ? filter(props.expandedNodeIds, x => x !== node.id)
        : [...props.expandedNodeIds, node.id];
      props.setExpandedNodeIds(nextExpandedNodeIds);
    },
  }),
  withScrollToSubSection,
)(ImportDocumentation);



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/index.js